import { Deserializable } from '../../protocols/deserializable';

export class ResetPasswordRequest implements Deserializable {
  constructor(public email: string = '', public code: string = '', public newPassword: string = '') {}

  onDeserialize = () => {};
}
